import { render, staticRenderFns } from "./AddTask.vue?vue&type=template&id=42702489&"
import script from "./AddTask.vue?vue&type=script&lang=js&"
export * from "./AddTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42702489')) {
      api.createRecord('42702489', component.options)
    } else {
      api.reload('42702489', component.options)
    }
    module.hot.accept("./AddTask.vue?vue&type=template&id=42702489&", function () {
      api.rerender('42702489', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectmanagement/AddTask.vue"
export default component.exports